import Icon from '../components/Icon.vue'

Icon.register({
  atlas: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M318.4 208c-5.3 31.2-25.6 57.2-53.3 70.4 7.7-19.1 12.7-43.4 14.2-70.4h39.1zM318.4 176h-39.1c-1.5-27-6.5-51.3-14.2-70.4 27.7 13.2 48 39.2 53.3 70.4zM224 97.3c7.7 7.5 20.8 34.4 23.4 78.7h-46.9c2.7-44.3 15.7-71.2 23.4-78.7zM182.9 105.6c-7.7 19.1-12.7 43.4-14.2 70.4h-39.1c5.3-31.2 25.6-57.2 53.3-70.4zM182.9 278.4c-27.7-13.2-48-39.2-53.3-70.4h39.1c1.5 27 6.5 51.3 14.2 70.4zM247.4 208c-2.7 44.3-15.7 71.2-23.4 78.7-7.7-7.5-20.8-34.4-23.4-78.7h46.9zM448 358.4c0 9.6-3.2 16-9.6 19.2-3.2 12.8-3.2 57.6 0 73.6 6.4 6.4 9.6 12.8 9.6 19.2v16c0 16-12.8 25.6-25.6 25.6h-326.4c-54.4 0-96-41.6-96-96v-320c0-54.4 41.6-96 96-96h326.4c16 0 25.6 9.6 25.6 25.6v332.8zM224 64c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128zM384 448v-64h-288c-16 0-32 12.8-32 32s12.8 32 32 32h288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/atlas.js
// module id = 630
// module chunks = 0